
import _ from 'underscore';
import { isValidUrl, getUrlProtocolAndDomain } from '@bingads-webui/url-util';


const isValidCustomUrlProtocol = (url) => {
  const uriRegex = /^(\S+:(\/\/)?)(\S+)/;
  return uriRegex.test(url);
};

const doesUrlContainUnsafeCharacters = (url) => {
  const specialCharactersRegex = /[\s<>{}]/;
  return specialCharactersRegex.test(url);
};

export const UrlLengthLimit = 2048;
/**
 * Validate a URL.
 * @param {String} url - Fully qualified ad HTTP/S URL, including the prefix.
 * @param {String} requiredUrlProtocolAndDomain - Protocol and domain name that the ad URL must use.
 * @param {Object} [i18n] - i18n library.
 * @param {Number} [urlLengthLimit] - Maximum number of characters allowed in the URL.
 * @param {Boolean} [customUrlProtocol] - Whether the URL can have a custom protocol.
 * @param {Boolean} [validateSpecialCharacters] - Whether to validate special characters in the URL.
 * @returns {String} - Null if URL is valid. Otherwise an error message.
 */
export function validateAdUrl(url, requiredUrlProtocolAndDomain, i18n = { getString: _.identity }, urlLengthLimit = UrlLengthLimit, customUrlProtocol = false, validateSpecialCharacters = false) {
  if (!url) {
    return i18n.getString(_TL_('Please enter a valid URL'));
  }

  if (validateSpecialCharacters && doesUrlContainUnsafeCharacters(url)) {
    return i18n.getString(_TL_('The URL contains invalid characters.'));
  }

  if (_.size(url) > urlLengthLimit) {
    return i18n.getString(_TL_('The number of characters in this field cannot exceed {{lengthLimit}}'), { lengthLimit: urlLengthLimit });
  }

  if ((customUrlProtocol && !isValidCustomUrlProtocol(url)) || (!customUrlProtocol && !isValidUrl(url))) {
    return i18n.getString(_TL_('Please enter a valid URL'));
  }

  if (!_.isEmpty(requiredUrlProtocolAndDomain)) {
    // Google requires search ads in the same ad group have the same display URL domain
    // See: https://support.google.com/adspolicy/answer/6088505?hl=en-GB
    const adUrlProtocolAndDomain = getUrlProtocolAndDomain(url);
    if (requiredUrlProtocolAndDomain !== adUrlProtocolAndDomain) {
      return i18n.getString(_TL_('This ad\'s final URL must have the same domain as the other ads in this campaign.'));
    }
  }

  return null;
}

const pathLengthLimitErrorMessages = [
  _TL_('Path 1 cannot exceed 15 characters.'),
  _TL_('Path 2 cannot exceed 15 characters.'),
];
const pathLengthLimit = 15;

export function validatePath(values, i18n) {
  const errors = [];
  const path1 = _.isEmpty(values[0]) ? '' : values[0].trim();
  const path2 = _.isEmpty(values[1]) ? '' : values[1].trim();
  if (_.isEmpty(path1) && !_.isEmpty(path2)) {
    errors.push(i18n.getString(_TL_('In order to use path 2, path 1 must also be used.')));
  }

  _.each(values, (field, index) => {
    if (field && _.size(field) > pathLengthLimit) {
      errors.push(i18n.getString(pathLengthLimitErrorMessages[index]));
    }
  });

  return errors;
}
